module.exports = __webpack_public_path__ + "static/media/login_bg_dark.a7d43107.png";